module.exports = __webpack_public_path__ + "static/media/nfe-icon.8936e012.png";